/**
 * Searches the FAQ's for the entered text
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/utils/each/each.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/traversal/filter/filter.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/attributes/hasclass/hasclass.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/traversal/closest/closest.js";

export default obj => {
	const text = [],
		cls = obj.get(0).classList[0],
		input = $("." + cls + "__search"),
		sections = $("." + cls + "__category", obj),
		faqs = $("." + cls + "__item", obj),
		hide = cls + "__item--hide";

	// extract text
	faqs.each(function () {
		const $this = $(this);
		text.push({
			obj: $this,
			text: $this.text().toLowerCase()
		});
	});

	// show search results as the user types
	input.on("keyup", () => {

		// get inputted value
		const value = input.val().toLowerCase().split(/\s+/).filter(item => item.length > 2);

		// search faqs
		$.each(text, (i, item) => {
			let found = true;

			// check each question
			if (value.length) {
				found = true;
				$.each(value, (v, val) => {
					if (item.text.indexOf(val) === -1) {
						found = false;
						item.obj.addClass(hide);
						return false;
					}
				});
			}
	
			// show item when match or nothing entered
			if (found) {
				item.obj.removeClass(hide);
			}
		});

		// open/close sections
		sections.each(function () {
			const children = faqs.filter((i, item) => {
				item = $(item);
				return item.closest(this).length && !item.hasClass(hide);
			}).length;
			$(".faqs__switch", this).prop("checked", children && value.length ? "checked" : "").trigger("change");
			$(".faqs__heading-found", this).text(children);
		});
	});
};
